
import { Container } from 'pixi.js';
import { TargetDirector } from './../common/TargetDirector';

export class GameUI extends Container {
    constructor() {
        super();

        // click point

        // speech bubbles
        this.objectiveArrowCont = new Container();
        this.tutorials = new Container();
        this.speechBubbles = new Container();
        // - gameui
        // minimap + score

        this.addChild(this.objectiveArrowCont, this.tutorials, this.speechBubbles);

        this.uiElements = [];
    }

    addTutorial(tutorial) {
        this.tutorials.addChild(tutorial);
    }

    removeTutorial(tutorial) {
        this.tutorials.removeChild(tutorial);
    }

    addBubble(bubble) {
        this.speechBubbles.addChild(bubble);
    }

    removeBubble(bubble) {
        this.speechBubbles.removeChild(bubble);
    }

    showShield(player) {

    }

    showObjectiveArrow(player, tilemap) {
        this.objectiveArrow = new TargetDirector(player, tilemap);
        this.objectiveArrowCont.addChild(this.objectiveArrow);
    }

    updateObjectiveArrow(objective){
        this.objectiveArrow.setTarget(objective);
    }

    hideObjectiveArrow(){
        this.objectiveArrow.bigChevron.visible = false;
        this.objectiveArrow.littleChevron.visible = false;
    }

    update(dt) {
        this.tutorials.children.forEach(tutorial => {
            if (tutorial.update) tutorial.update(dt);
        });
        if (this.objectiveArrow){
            this.objectiveArrow.update();
        }
    }
}
